export const SCORING_SIMULATE_LTV = '@scoring/SCORING_SIMULATE_LTV';
export const SCORING_SIMULATE_LTV_ERROR = '@scoring/SCORING_SIMULATE_LTV_ERROR';
export const SCORING_SIMULATE_LTV_LOADING = '@scoring/SCORING_SIMULATE_LTV_LOADING';
export const SCORING_SIMULATE_LTV_SUCCESS = '@scoring/SCORING_SIMULATE_LTV_SUCCESS';

export const SCORING_RESET_LTV = '@scoring/SCORING_RESET_LTV';